import {
  ClipboardCheck,
  ClipboardCopy,
  ClipboardList,
  ClipboardPaste,
  ClipboardPenLine,
  ClipboardX,
} from "lucide-react";
import t from "@/lang/lang";
import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";

export const State = FulfillmentState;
export type State = FulfillmentState;

export function StateInfo({
  state,
  withTitle = true,
  withDescription = false,
}: {
  state: State;
  withTitle?: boolean;
  withDescription?: boolean;
}) {
  switch (state) {
    case FulfillmentState.Zero:
      return (
        <span className="flex items-center">
          <ClipboardPenLine className="mr-2 h-4 w-4" />
          {withTitle && <span>{t("Vorbereitung")}</span>}
          {withDescription && (
            <span className="ml-2">
              ({t("Inhalt wird erstellt und geprüft")})
            </span>
          )}
        </span>
      );
    case FulfillmentState.Planning:
      return (
        <span className="flex items-center">
          <ClipboardPaste className="mr-2 h-4 w-4" />
          {withTitle && <span>{t("Planung")}</span>}
          {withDescription && (
            <span className="ml-2">
              ({t("Termin mit Kunde wird koordiniert")})
            </span>
          )}
        </span>
      );
    case FulfillmentState.Execution:
      return (
        <span className="flex items-center">
          <ClipboardList className="mr-2 h-4 w-4" />
          {withTitle && <span>{t("Bearbeitung")}</span>}
          {withDescription && (
            <span className="ml-2">({t("Arbeiten werden durchgeführt")})</span>
          )}
        </span>
      );
    case FulfillmentState.Executed:
    case FulfillmentState.PartiallyExecuted:
      return (
        <span className="flex items-center">
          <ClipboardCopy className="mr-2 h-4 w-4" />
          {withTitle && <span>{t("Prüfung")}</span>}
          {withDescription && (
            <span className="ml-2">
              (
              {t(
                "Prüfung ob Unterlagen fehlen, Folgearbeiten notwendig sind, ...",
              )}
              )
            </span>
          )}
        </span>
      );
    case FulfillmentState.Completed:
      return (
        <span className="flex items-center">
          <ClipboardCheck className="mr-2 h-4 w-4" />
          {withTitle && <span>{t("Fertig")}</span>}
          {withDescription && (
            <span className="ml-2">({t("Bereit für Rechnungsstellung")})</span>
          )}
        </span>
      );
    case FulfillmentState.Cancelled:
      return (
        <span className="flex items-center">
          <ClipboardX className="mr-2 h-4 w-4" />
          {withTitle && <span>{t("Abgebrochen")}</span>}
          {withDescription && (
            <span className="ml-2">({t("Auftrag wurde abgebrochen")})</span>
          )}
        </span>
      );
  }
}
